let bsParams = {
    
    firstYear:'',     // [2017]年度
    firstTotalSales:'',     // [2017]年销售收入（万元）
    firstTotalProfit:'',     // [2017]年利润总额（万元）
	firstSales:'',     // [2017]连续型电子销售收入（万元）
	firstProfit:'',     // [2017]连续型电子利润总额（万元）
	
	secondYear:'',     // [2018]年度
	secondTotalSales:'',     // [2018]年销售收入（万元）
	secondTotalProfit:'',     // [2018]年利润总额（万元）
	secondSales:'',     // [2018]连续型电子销售收入（万元）
	secondProfit:'',     // [2018]连续型电子利润总额（万元）
	
	publishMaterialId:'',     // publishMaterialId
	publishId:'',     // 出版单位ID
	id:'',     // id

}

let paramsRule = {
    
    firstTotalSales:[
    	{ required:true, message:'不能为空！', trigger:'change' },
    ],     // [2017]年销售收入（万元）
    firstTotalProfit:[
    	{ required:true, message:'不能为空！', trigger:'change' },
    ],     // [2017]年利润总额（万元）
	firstSales:[
		{ required:true, message:'不能为空！', trigger:'change' },
	],     // [2017]连续型电子销售收入（万元）
	firstProfit:[
		{ required:true, message:'不能为空！', trigger:'change' },
	],     // [2017]连续型电子利润总额（万元）
	
	secondTotalSales:[
		{ required:true, message:'不能为空！', trigger:'change' },
	],     // [2018]年销售收入（万元）
	secondTotalProfit:[
		{ required:true, message:'不能为空！', trigger:'change' },
	],     // [2018]年利润总额（万元）
	secondSales:[
		{ required:true, message:'不能为空！', trigger:'change' },
	],     // [2018]连续型电子销售收入（万元）
	secondProfit:[
		{ required:true, message:'不能为空！', trigger:'change' },
	],     // [2018]连续型电子利润总额（万元）

}

export { bsParams,paramsRule }


// WEBPACK FOOTER //
// ./src/components/LongParams/paramsSEt3.js